class ConsultaNcmModal {
    $onInit() {
        this.contratoId = this.resolve.contratoId
        this.ncm = this.resolve.ncm

        this.select = ({classificacaoBusca}) => {
            this.close({$value: classificacaoBusca})
        }
    }
}

angular.module("eficienciaFiscalModule")
    .component("consultaNcmModal", {
        controller: [ConsultaNcmModal],
        bindings: {
            close: '&',
            resolve: '<'
        },
        template: `
            <modal modal-title="Consulta de NCM na tabela TIPI" close="$ctrl.close">
                <modal-body>
                    <div class="clearfix">
                        <consulta-ncm contrato-id="$ctrl.contratoId" ncm="$ctrl.ncm" on-select="$ctrl.select(ncm)"></consulta-ncm>
                    </div>
                </modal-body>
                <modal-footer>
                    <button type="button" class="btn btn-default" ng-click="$ctrl.close()">Fechar</button>
                </modal-footer>
            </modal>
        `
    })